<script setup>
import ModalWrapper from '@/modals/ModalWrapper';
import { ref } from 'vue';
import { useToast } from 'vue-toastification';
import { useMemberAssessmentStore } from '@/stores/memberAssessment';
import { trans } from 'laravel-vue-i18n';
import { useOptionsStore } from '@/stores/options';
import { storeToRefs } from 'pinia';

const optionsStore = useOptionsStore();
const { assessments, memberProfilesOptions } = storeToRefs(optionsStore);

const props = defineProps({
    assessment: {
        type: Object,
        default: () => ({
            //
        })
    },
    mode: {
        type: String,
        default: 'Create'
    }
});

const emit = defineEmits(['close-modal']);
const toast = useToast();
const { store, update } = useMemberAssessmentStore();

const form = ref({
    assessment_id: props.assessment?.assessment_id || null,
    member_profile_id: props.assessment?.member_profile_id || null,
    assessment_domain_id: props.assessment?.assessment_domain_id || null,
    status_id: props.assessment?.status_id || null,
});

const save = async () => {

    const action = props.mode === 'Edit' ? update : store;

    try {
        await action({
            ...form.value,
            hash: props.assessment?.hash || null,
        });
        toast.success(trans('actions.update.success', { type: trans('label.member_profile') }));
        emit('close-modal');
    } catch (error) {
        toast.error(trans('actions.update.error', { type: trans('label.member_profile') }));
    }
};
</script>

<template>
<ModalWrapper>
    <template #header>{{ $t('label.mode_what', { 'mode' : mode, 'what' : $t('label.member_assessment') }) }}</template>
    <template #subheader>{{ $t('label.create_or_edit', { 'what' : $t('label.member_assessment') }) }}</template>
    <form @submit.prevent="save">
        <div class="grid md:grid-cols-2 gap-x-4 gap-y-3">
            <StyledDropdown
                v-model="form.assessment_id"
                name="assessment_id"
                :options="assessments"
                :label="$t('label.assessment')"
                :clearable="false" />
            <StyledDropdown
                v-model="form.member_profile_id"
                name="member_profile_id"
                :options="memberProfilesOptions"
                :label="$t('label.member_profile')"
                :clearable="false" />
        </div>
    </form>
    <template #footer>
        <StyledSaveButton modal @save="save" />
    </template>
</ModalWrapper>
</template>
